module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-2-6.8ec14221.png";